import React from 'react'

const NotFound = () => (
  <div className="alert alert-warning" role="alert">
    <h2>Lapa nav atrasta</h2>
    Diemžēl, Jūsu meklētā lapa nav atrasta.
  </div>
)
export default NotFound
